export default {
  /**
   * Get 2FA status for current user
   * @param {Object} http - Vue $http instance
   * @returns {Promise} - Response with enabled, verified status
   */
  getStatus(http) {
    return http.get('/api/v1/users/2fa/status')
  },

  /**
   * Initiate 2FA setup
   * @param {Object} http - Vue $http instance
   * @returns {Promise} - Response with secret, qr_code, provisioning_uri
   */
  setup(http) {
    return http.post('/api/v1/users/2fa/setup')
  },

  /**
   * Verify 2FA setup with TOTP code
   * @param {Object} http - Vue $http instance
   * @param {string} code - 6-digit TOTP code
   * @returns {Promise} - Response with success status and recovery codes
   */
  verify(http, code) {
    return http.post('/api/v1/users/2fa/verify', { code })
  },

  /**
   * Disable 2FA
   * @param {Object} http - Vue $http instance
   * @param {string} password - Current password
   * @param {string} code - TOTP or recovery code
   * @returns {Promise}
   */
  disable(http, password, code) {
    return http.post('/api/v1/users/2fa/disable', { password, code })
  },

  /**
   * Validate 2FA during login (no auth required - uses pending token)
   * @param {Object} http - Vue $http instance
   * @param {string} pendingToken - Pending token from login
   * @param {string} code - TOTP or recovery code
   * @returns {Promise} - Response with full JWT token
   */
  validateLogin(http, pendingToken, code) {
    return http.post('/auth/2fa/validate', {
      pending_token: pendingToken,
      code
    })
  },

  /**
   * Regenerate recovery codes
   * @param {Object} http - Vue $http instance
   * @param {string} password - Current password
   * @param {string} code - TOTP code
   * @returns {Promise} - Response with new recovery codes
   */
  regenerateRecoveryCodes(http, password, code) {
    return http.post('/api/v1/users/2fa/recovery-codes/regenerate', {
      password,
      code
    })
  }
}
